import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { GetWritebackErrorMessageFn, UseWritebackErrorResults } from './use-writeback-error.type';
import { extractErrorMessage } from './writeback-error.util';

export const useWritebackError = (): UseWritebackErrorResults => {
  const { t } = useTranslation('forms');
  const defaultErrorMessage = t('Writeback retry failed!');

  const getWBErrorMessage = useCallback<GetWritebackErrorMessageFn>(
    ({ errorString = '', separator }) => {
      return extractErrorMessage({
        errorString,
        defaultErrorMessage,
        separator,
      });
    },
    [defaultErrorMessage]
  );

  return {
    getWBErrorMessage,
    defaultErrorMessage,
  };
};
